'use client'

// SignalGlyph — the product's own mark language for walker signals. Clean
// SVG strokes, no emojis (house rule); swap these paths for hand-drawn art
// whenever it exists.

const GOLD = '#fde68a'

export function SignalGlyph({ kind, size = 28 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 30 30',
    fill: 'none',
    stroke: GOLD,
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    style: { filter: 'drop-shadow(0 0 5px rgba(250,204,21,0.45))' },
  }
  switch (kind) {
    case 'whistle':
      return (
        <svg {...common}>
          <circle cx="8" cy="15" r="2" fill={GOLD} stroke="none" />
          <path d="M13 9 a9 9 0 0 1 0 12" />
          <path d="M17 6 a13 13 0 0 1 0 18" opacity="0.7" />
        </svg>
      )
    case 'wave':
      return (
        <svg {...common}>
          <path d="M6 20 Q15 6 24 20" />
          <path d="M9 22 Q15 12 21 22" opacity="0.6" />
        </svg>
      )
    case 'orb':
      return (
        <svg {...common}>
          <circle cx="15" cy="15" r="5.5" fill={GOLD} fillOpacity="0.25" />
          <circle cx="15" cy="15" r="10" opacity="0.4" />
        </svg>
      )
    case 'question':
      return (
        <svg {...common}>
          <path d="M11 11 a4 4 0 1 1 5.5 3.7 q-1.5 0.8 -1.5 2.8" />
          <circle cx="15" cy="22.5" r="1.3" fill={GOLD} stroke="none" />
        </svg>
      )
    case 'apple':
      return (
        <svg {...common}>
          <circle cx="15" cy="17.5" r="7" />
          <path d="M15 10.5 q0.5 -3.5 3.5 -4.5" />
          <path d="M18.5 8.5 q3 0 3.5 2.5 q-3 0.5 -3.5 -2.5 z" fill={GOLD} fillOpacity="0.4" />
        </svg>
      )
    case 'note':
      return (
        <svg {...common}>
          <circle cx="11.5" cy="21" r="3.2" fill={GOLD} fillOpacity="0.35" />
          <path d="M14.7 21 V8" />
          <path d="M14.7 8 q5.5 1 5.5 6" opacity="0.8" />
        </svg>
      )
    default:
      return null
  }
}

export default SignalGlyph
